module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/stores/stores.component.css
// module id = ./src/app/stores/stores.component.css
// module chunks = main